// extracted by mini-css-extract-plugin
export default {"form":"dynamic-form_form__i0pms"};